import { apiClient } from "@config/apiClient";
import { API_URL } from "@config/constants";
import type { IFeedbackOption, ISubmitFeedbackPayload } from "@interfaces/thread.interface";

class FeedbackService {
  private URL = `${API_URL}/feedback`;

  async getFeedbackOptions(): Promise<IFeedbackOption[]> {
    return apiClient.get(`${this.URL}/options/`);
  }

  async createThreadContextFeedback(payload: ISubmitFeedbackPayload): Promise<void> {
    return apiClient.post(`${this.URL}/thread-context/`, payload);
  }

  async updateThreadContextFeedback(
    threadId: string,
    payload: { reasons?: string[]; comment?: string }
  ): Promise<void> {
    return apiClient.patch(`${this.URL}/thread-context/${threadId}/`, payload);
  }
}

const feedbackService = new FeedbackService();
export default feedbackService;
